/**
 * TECHNICAL CROSSHAIR CURSOR // KEVIN ARTHUR DE LIMA
 * Crosshairs that snap into brackets [ ] over interactive elements.
 */

export function initCustomCursor() {
  if (window.matchMedia('(pointer: coarse)').matches) return;

  const cursor = document.createElement('div');
  cursor.className = 'custom-cursor';
  cursor.innerHTML = `
    <div class="cursor-ch-h"></div>
    <div class="cursor-ch-v"></div>
    <span class="cursor-bracket-l">[</span>
    <span class="cursor-bracket-r">]</span>
  `;
  document.body.appendChild(cursor);

  let mouseX = window.innerWidth / 2;
  let mouseY = window.innerHeight / 2;
  let curX = mouseX;
  let curY = mouseY;

  window.addEventListener('mousemove', e => {
    mouseX = e.clientX;
    mouseY = e.clientY;
  }, { passive: true });

  function render() {
    curX += (mouseX - curX) * 0.35;
    curY += (mouseY - curY) * 0.35;
    cursor.style.transform = `translate3d(${curX}px, ${curY}px, 0)`;
    requestAnimationFrame(render);
  }
  requestAnimationFrame(render);

  const interactiveSelectors = 'a, button, input, textarea, .skill-row, .project-card, [data-interactive]';

  document.addEventListener('mouseover', e => {
    if (e.target.closest(interactiveSelectors)) {
      document.body.classList.add('cursor-active');
    }
  });

  document.addEventListener('mouseout', e => {
    if (e.target.closest(interactiveSelectors)) {
      document.body.classList.remove('cursor-active');
    }
  });
}
